// Ticket usage (voucher.usage_type): '1' = eye-check, '2' = QR scan
export const USAGE_TYPE_OPTIONS = Object.freeze([
    ['1', '目視確認'],
    ['2', 'QR表示'],
]);

// Ticket package category (t_ticket_package.ticket_package_category)
export const TICKET_PACKAGE_CATEGORY_OPTIONS = Object.freeze([
    ['0', '有料乗車券'],
    ['1', '0円乗車券'],
]);

// Ticket level (t_ticket_package.ticket_level)
export const TICKET_LEVEL_OPTIONS = Object.freeze(['0', '1', '2', '3']);

/**
 * チケットジャンル (t_ticket_package.ticket_genre)
 */
export const TICKET_GENRE_OPTIONS = Object.freeze([
    ['C00601', '買い物'],
    ['C00602', 'ランチ'],
    ['C00603', 'ディナー'],
    ['C00604', 'お酒'],
    ['C00605', '美容'],
    ['C00606', '遊ぶ'],
    ['C00607', 'その他'],
]);
